import { agileSuccess } from './agileHelper';
import { ajaxCall } from './ajax';

export function agileFormEiws() {
    return {
        step: 1,
        fields1: [
            {
                name: 'first_name',
                label: 'Voornaam',
                value: '',
                error: '',
                required: true,
            },
            {
                name: 'last_name',
                label: 'Achternaam',
                value: '',
                error: '',
                required: true,
            },
            {
                name: 'email_address',
                label: 'Mailadres',
                value: '',
                error: '',
                required: true,
            },
        ],
        fields2: [
            {
                name: 'phone_number',
                label: 'Mobiel nummer',
                value: '',
                error: '',
                required: false,
            },
            {
                name: 'company_name',
                label: 'Bedrijf',
                value: '',
                error: '',
                required: true,
            },
            {
                name: 'postal_code',
                label: 'Postcode',
                value: '',
                error: '',
                required: false,
            },
            {
                name: 'house_number',
                label: 'Huisnummer',
                value: '',
                error: '',
                required: false,
            },
            {
                name: 'street',
                label: 'Straatnaam',
                value: '',
                error: '',
                required: false,
            },
            {
                name: 'city',
                label: 'Plaats',
                value: '',
                error: '',
                required: false,
            },
            {
                name: 'website',
                label: 'Website',
                value: '',
                error: '',
                required: true,
            },
        ],

        action: 'agileFormEiws',
        dialog: '',
        ownersPartners: '',
        ownersPartnersError: '',
        currentRevenue: '',
        currentRevenueError: '',
        goalRevenue: '',
        goalRevenueError: '',
        topChallenges: '',
        topChallengesError: '',
        topOpportunities: '',
        topOpportunitiesError: '',
        valid: false,
        loading: false,
        success: false,
        tags: [],

        validateStep1() {
            this.valid = true;
            this.fields1.forEach((field, i) => (this.fields1[i].error = ''));
            this.fields1.forEach((field, i) => {
                if (field.required == true && field.value === '') {
                    this.valid = false;
                    this.fields1[i].error = 'Kun u dit veld nog invullen?';
                    this.dialog = 'Een of meerdere velden moeten nog ingevuld worden';
                }
            });

            if (this.valid) {
                this.step = 2;
            }
        },

        validateStep2() {
            this.valid = true;
            this.fields2.forEach((field, i) => (this.fields2[i].error = ''));
            this.ownersPartnersError = '';

            this.fields2.forEach((field, i) => {
                if (field.required == true && field.value === '') {
                    this.valid = false;
                    this.fields2[i].error = 'Kun u dit veld nog invullen?';
                    this.dialog = 'Een of meerdere velden moeten nog ingevuld worden';
                }
            });

            if (this.ownersPartners === '') {
                this.valid = false;
                this.ownersPartnersError = 'Kun u dit veld nog invullen?';
                this.dialog = 'Een of meerdere velden moeten nog ingevuld worden';
            }

            if (this.valid === true) {
                this.step = 3;
            }
        },

        validateStep3() {
            this.valid = true;
            this.currentRevenueError = '';
            this.goalRevenueError = '';
            this.topChallengesError = '';
            this.topOpportunitiesError = '';

            if (this.currentRevenue === '') {
                this.valid = false;
                this.currentRevenueError = 'Kun u dit veld nog invullen?';
                this.dialog = 'Een of meerdere velden moeten nog ingevuld worden';
            }

            if (this.goalRevenue === '') {
                this.valid = false;
                this.goalRevenueError = 'Kun u dit veld nog invullen?';
                this.dialog = 'Een of meerdere velden moeten nog ingevuld worden';
            }

            if (this.topChallenges === '') {
                this.valid = false;
                this.topChallengesError = 'Kun u dit veld nog invullen?';
                this.dialog = 'Een of meerdere velden moeten nog ingevuld worden';
            }

            if (this.topOpportunities === '') {
                this.valid = false;
                this.topOpportunitiesError = 'Kun u dit veld nog invullen?';
                this.dialog = 'Een of meerdere velden moeten nog ingevuld worden';
            }

            if (this.valid === true) {
                this.submitData();
            }
        },

        gotoStep(val) {
            this.step = parseInt(val);
        },

        async submitData() {
            this.dialog = '';
            this.valid = true;
            this.loading = true;
            await this.attemptSend();
            this.loading = false;
        },

        async attemptSend() {
            // client side check
            this.fields1.forEach((field, i) => {
                if (field.value === '') {
                    this.valid = false;
                    this.fields1[i].error = 'Kun u dit veld nog invullen?';
                    this.dialog = 'Een of meerdere velden moeten nog ingevuld worden';
                }
            });

            this.fields2.forEach((field, i) => {
                if (field.required == true && field.value === '') {
                    this.valid = false;
                    this.fields2[i].error = 'Kun u dit veld nog invullen?';
                    this.dialog = 'Een of meerdere velden moeten nog ingevuld worden';
                }
            });

            if (this.ownersPartners === '') {
                this.valid = false;
                this.ownersPartnersError = 'Kun u dit veld nog invullen?';
                this.dialog = 'Een of meerdere velden moeten nog ingevuld worden';
            }

            if (this.currentRevenue === '') {
                this.valid = false;
                this.currentRevenueError = 'Kun u dit veld nog invullen?';
                this.dialog = 'Een of meerdere velden moeten nog ingevuld worden';
            }

            if (this.goalRevenue === '') {
                this.valid = false;
                this.goalRevenueError = 'Kun u dit veld nog invullen?';
                this.dialog = 'Een of meerdere velden moeten nog ingevuld worden';
            }

            if (this.topChallenges === '') {
                this.valid = false;
                this.topChallengesError = 'Kun u dit veld nog invullen?';
                this.dialog = 'Een of meerdere velden moeten nog ingevuld worden';
            }

            if (this.topOpportunities === '') {
                this.valid = false;
                this.topOpportunitiesError = 'Kun u dit veld nog invullen?';
                this.dialog = 'Een of meerdere velden moeten nog ingevuld worden';
            }

            if (!this.valid) {
                this.loading = false;
                return;
            }

            let data = { tags: this.tags };
            this.fields1.forEach((field) => (data[field.name] = field.value));
            this.fields2.forEach((field) => (data[field.name] = field.value));

            data['owners_partners'] = this.ownersPartners;
            data['current_revenue'] = this.currentRevenue;
            data['goal_revenue'] = this.goalRevenue;
            data['top_challenges'] = this.topChallenges;
            data['top_opportunities'] = this.topOpportunities;

            let { data: responseData } = await ajaxCall(this.action, data);

            if (responseData.success) {
                // this.dialog = "Bedankt voor uw interesse";
                this.success = true;

                if (typeof _agile !== 'undefined') {
                    _agile.set_email(
                        this.fields1[this.fields1.findIndex((field) => field.name === 'email_address')].value
                    );
                }
                agileSuccess({
                    email: this.fields[this.fields.findIndex((field) => field.name === 'email_address')].value,
                });
            } else {
                this.dialog = responseData.data.dialog;

                for (var [key, errorMessage] of Object.entries(responseData.data.errors)) {
                    let errorKey = this.fields1.findIndex((field) => key === field.name);
                    this.fields1[errorKey].error = errorMessage;
                }
            }
        },
    };
}
